import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

declare var $: any;

export class HttpErrorInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        //this.authenticationService.logout();
        //location.reload(true);
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('tokenExp');
        localStorage.removeItem('ip');
      }

      $('#maskLoading').css('display', 'none');
      const error = err.error.message || err.statusText;
      return throwError(err);
    }));
  }

  /*intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    return next.handle(request)
      .pipe(
        catchError( (error: HttpErrorResponse) => {
          let errMsg = '';
          // Client Side Error
          if (error.error instanceof ErrorEvent) {
            errMsg = `Error: ${error.error.message}`;
          }
          else {  // Server Side Error
            errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
          }
          return throwError(errMsg);
        })
      );
  }*/
}
